import { render, staticRenderFns } from "./eveningPaper.vue?vue&type=template&id=0cad5f30&scoped=true&"
import script from "./eveningPaper.vue?vue&type=script&lang=js&"
export * from "./eveningPaper.vue?vue&type=script&lang=js&"
import style0 from "./eveningPaper.vue?vue&type=style&index=0&id=0cad5f30&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cad5f30",
  null
  
)

export default component.exports